import { Meta, MetaProps } from '@/src/components/common/Meta';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, Container, ContentLayout, ExpandableSection, Grid, Header } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { QuestionSectionKeys, QuestionSections, questions } from './faq.config';
import './FAQ.scss';

const SeoDefinitions: Record<QuestionSectionKeys, MetaProps | undefined> = {
  general: {
    title: i18nKeys.meta.general.title,
    description: i18nKeys.meta.general.description,
    keywords: i18nKeys.meta.general.keywords,
  },
  host: {
    title: i18nKeys.meta.host.title,
    description: i18nKeys.meta.host.description,
    keywords: i18nKeys.meta.host.keywords,
  },
  facilitating: {
    title: i18nKeys.meta.facilitator.title,
    description: i18nKeys.meta.facilitator.description,
    keywords: i18nKeys.meta.facilitator.keywords,
  },
  play: {
    title: i18nKeys.meta.play.title,
    description: i18nKeys.meta.play.description,
    keywords: i18nKeys.meta.play.keywords,
  },
};

const FAQ = () => {
  const { t } = useTranslation();
  const { section = 'general' }: { section: QuestionSectionKeys } = useParams();

  const seoDefinition = SeoDefinitions[section];
  const sectionQuestions = questions[section];

  return (
    <div className="faq-container">
      <ContentLayout header={<Header>{t(QuestionSections[section].title)}</Header>}>
        <Meta
          title={seoDefinition?.title ? t(seoDefinition.title) : undefined}
          description={seoDefinition?.description ? t(seoDefinition.description) : undefined}
          keywords={seoDefinition?.keywords ? t(seoDefinition.keywords) : undefined}
        />
        <Grid
          gridDefinition={Array(sectionQuestions.length)
            .fill(0)
            .map(() => ({ colspan: 12 }))}
        >
          {sectionQuestions.map((question, index) => (
            <Container key={question.question}>
              <ExpandableSection
                headerText={
                  <Box variant="h3" fontSize="heading-s" padding="n">
                    {t(question.question)}
                  </Box>
                }
                defaultExpanded={index === 0}
              >
                <div className="ans-div-style">
                  <Grid gridDefinition={[{ colspan: { xl: 9, l: 9, m: 9, s: 9, xs: 12, xxs: 12 } }]}>
                    <Box>{question.answer}</Box>
                  </Grid>
                </div>
              </ExpandableSection>
            </Container>
          ))}
        </Grid>
      </ContentLayout>
    </div>
  );
};

export default FAQ;
